import * as React from "react";
import info from "../info.json";
import { Link, navigate } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import Form from "./form";
import { IconArrowNarrowRight } from "@tabler/icons-react";
import { animate, motion } from "framer-motion";

export default function ProductCard(props) {
  const [isOver, setIsOver] = React.useState(false);
  const [isOn, setIsOn] = React.useState(false);
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const [touchStartX, setTouchStartX] = React.useState(0);

  React.useEffect(() => {
    // Espera hasta que el componente esté montado para cargar la imagen
    setImageLoaded(true);

  }, []);

  return (
    <div
      className={`flower-card min-w-[150px] sm:min-w-[130px] group duration-300 ease-in-out transition-all scale-100  ${props.isSearch === false ? 'md:hover:scale-[1.20]' : 'md:hover:scale-[1.1]'} cursor-pointer flex flex-col justify-center z-0 hover:z-10`}
      key={props.index}
      id={props.index}
      to={`/flower/` + props.slug}
      onMouseEnter={() => {
        setIsOver((prevState) => !prevState);
      }}
      onTouchStart={(e)=>{
        setTouchStartX(e.touches[0].clientX)
      }}
      onTouchEnd={(e)=>{
        const touchEndX =  e.changedTouches[0].clientX;
        const deltaX = Math.abs(touchEndX - touchStartX);
        if (deltaX < 10) { 

        var closest = e.target.closest(".flower-card")      

          if (closest) {
            closest.click()
            
          }
        }

      }}
  
      onClick={() => {
        navigate(`/flower/` + props.slug);
      }}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div className=" h-fit -mt-[10vh] lg:mt-0">
        {imageLoaded && (
          <GatsbyImage
            image={props.image}
            alt={props.alt}
            className="object-contain object-bottom max-h-[50vh] xs:max-h-[60vh]"
            draggable={false} // ❌ evita arrastrar la imagen
            onContextMenu={(e) => e.preventDefault()} // Bloquea clic derecho
          />
        )}

         { props.isSearch ? 
         
         <div className="w-full">
            <h6
              className={`block uppercase text-sm  w-full text-center pt-4 transition-all ease-in-out duration-300`}
            >
              {props.title}
            </h6>
          </div>
:
        <div className="absolute -bottom-15 left-[50%] -translate-x-2/4	w-fit">
          {props.isNew && (
            <span
              className={`hidden lg:block uppercase text-sm w-full text-center pt-4 pb-0 -mb-4 transition-all ease-in-out duration-300 opacity-0 group-hover:opacity-100 text-red`}
            >
              ¡NEW!
            </span>
          )}
          <h6
            className={`hidden lg:block uppercase text-sm underline underline-offset-[10px] w-full text-center pt-4 transition-all ease-in-out duration-300 opacity-0 group-hover:opacity-100`}
          >
            {props.title}
          </h6>

          <Link
            className="group justify-center flex flex-col items-center lg:hidden transition-all ease-in-out duration-300 opacity-0 pt-4"
            onTouchEnd={() => {
              navigate(`/flower/` + props.slug);
            }}
          >
            {props.isNew && (
              <span
                className={`uppercase text-sm w-full text-center  text-red`}
              >
                ¡NEW!
              </span>
            )}

            <div className="flex items-center">
              <h6
                className={`uppercase w-fit text-base underline underline-offset-[10px] whitespace-nowrap`}
              >
                {props.title}
              </h6>
            </div>
          </Link>
        </div>

}
      </div>
    </div>
  );
}
